import { ICompanyServicePlan } from "modules/company/types";

const areIntegrationsEnabled = (plan: ICompanyServicePlan | null): boolean =>
  Boolean(plan?.settings?.company.integrations);

export default areIntegrationsEnabled;
